import { useContext, useState } from "react";
import { React } from "react";
import { UserContext } from "../../UserContext";
import { useEffect } from "react";
import LoaderTeacher from "../../Loader/Loader_Teacher";
import { List } from "antd";
import './Course.css';



const MyCourses = () =>{
    const [courses,setCourses] = useState();
    const [loading,setLoading] = useState(false);
    const {instructorapiuri,token} = useContext(UserContext)
    const fetchCourseData = async () => {
			try {
				const response = await fetch(
					`${instructorapiuri}/inst/getcourses/`,
					{
						method: "GET",
						mode: "cors",
						headers: {
							Authorization: "Bearer " + token,
						},
					}
				);

                console.log(response);


				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}

				const data = await response.json();
				console.log("Received data:", data);

				setCourses(data.courses);
				setLoading(false);
                console.log(data.courses);
			} catch (error) {
				console.error("Error fetching course data:", error);
				setLoading(false);
			}
		};

        useEffect(() => {
					fetchCourseData();
				}, []);

				if (loading) {
					return (
						<div
							style={{
								position: "absolute",
								top: "50%",
								right: "30%",
								transform: "tranlate(-50%,-50%)",
							}}>
							<LoaderTeacher loader_text={"Generating content"} />
						</div>
					);
				}

    return (
			<h1>
				My courses
				<List
                    className="instructor-course-list"
					grid={{ gutter: 16, column: 1 }}
					dataSource={courses}
					renderItem={(course) => (
						<li>
							{course.courseOn}	for {course.target} with duration of {course.duration}
						</li>
					)}
				/>
			</h1>
		);
}

export default MyCourses;